import React from 'react';

export interface TimelineItem {
  id: string | number;
  title: string;
  description?: string;
  time: string;
  status?: 'completed' | 'current' | 'upcoming';
  icon?: string;
}

export const Timeline = ({ items, className = '' }: { items: TimelineItem[]; className?: string }) => {
  return (
    <div className={`relative pl-4 border-l-2 border-gray-100 space-y-6 ${className}`}>
      {items.map((item) => {
        const isCompleted = item.status === 'completed';
        const isCurrent = item.status === 'current';
        
        return (
          <div key={item.id} className="relative">
            <div className={`absolute -left-[23px] w-4 h-4 rounded-full border-2 bg-white flex items-center justify-center ${
              isCompleted ? 'border-green-500' : isCurrent ? 'border-brand-500 shadow-[0_0_0_3px_rgba(var(--brand-500),0.2)]' : 'border-gray-300'
            }`}>
              {isCompleted && <div className="w-2 h-2 rounded-full bg-green-500" />}
              {isCurrent && <div className="w-2 h-2 rounded-full bg-brand-500" />}
            </div>
            
            <div className="pl-3">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-1">
                <h4 className={`text-sm font-medium ${isCurrent ? 'text-gray-900' : 'text-gray-700'}`}>
                  {item.icon && <i className={`${item.icon} mr-1.5 text-gray-400`} />}
                  {item.title}
                </h4>
                <time className="text-xs text-gray-500 font-medium">{item.time}</time>
              </div>
              {item.description && (
                <p className="text-sm text-gray-500 mt-1 leading-relaxed">{item.description}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
